import de from './de.json';
import fr from './fr.json';
import it from './it.json';

export interface TranslationTable {
  errors: Record<string, string>;
  labels: Record<string, string>;
}

export type LanguageCode = "de" | "en" | "fr" | "it";
export type TranslationMap = Record<string, TranslationTable>;

const default_translation_map: Record<string, TranslationTable> = {
  de,
  fr,
  it
};

export function getTranslation(lang?: LanguageCode, translation_map?: TranslationMap): TranslationTable {
  let _translation_map = translation_map || default_translation_map;
  if (lang && lang in _translation_map) {
    return _translation_map[lang];
  }
  return _translation_map['de'];
}
